import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT
var roottj = window.TJAPI_ROOT


export const getjxcList = (params) => {
  return axios.post(root + '/voucher/accountresultbz/list', qs.stringify(params))
}

//反结账
export const deleteData = (params) => {
  return axios.post(root + '/voucher/accountresultbz/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/voucher/accountresultbz/detail', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/voucher/accountresultbz/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/voucher/accountresultbz/save', qs.stringify(params))
  }
}


//获取统计数据
export const getListTJ = (params) => {
  return axios.post(roottj + '/voucher/accountresultbz/getListTJ', qs.stringify(params))
}

export const getListManage = (params) => {
  return axios.post(root + '/voucher/accountresultbz/getListTJ', qs.stringify(params))
}



//最近的结账日期
export const JieZhangDate = (params) => {
  return axios.post(root + '/voucher/accountresultbz/JieZhangDate', qs.stringify(params), {noloading: true})
}

//获取对账页面数据
export const getDuiZhangData = (params) => {
  return axios.post(root + '/voucher/accountresultbz/getDuiZhangData', qs.stringify(params))
}

export const getDuiZhangCus = (params) => {
  return axios.post(root + '/voucher/accountresultbz/getDuiZhangCus', qs.stringify(params))
}

export const customerBalance = (params) => {
  return axios.post(root + '/recharge/rechargebalabce/customerBalance', qs.stringify(params))
}


export const getDuiZhangDataYinfu = (params) => {
  return axios.post(root + '/voucher/accountresultbz/getDuiZhangDataYinfu', qs.stringify(params))
}

//结账
export const jieZhang = (params) => {
  return axios.post(root + '/voucher/accountresultbz/jieZhang', qs.stringify(params))
}

//日结户销售数据导出
export const rijieExport = (params) => {
  return axios.post(root + '/voucher/accountresultbz/rijieExport', qs.stringify(params))
}

//导出销售明细
export const exportSalesDetail = (params) => {
  return axios.post(root + '/voucher/accountresultbz/exportSalesDetail', qs.stringify(params))
}

//年汇总对账单
export const getYearSummary = (params) => {
  return axios.post(root + '/voucher/accountresultbz/getYearSummary', qs.stringify(params))
}

//应付账款全年汇总
export const getAnnualSummary = (params) => {
  return axios.post(root + '/voucher/accountresultbz/getAnnualSummary', qs.stringify(params))
}

//批量更新逾期控制状态
export const batchUpdateOverduecontrol = (params) => {
  return axios.post(root + '/voucher/accountresultbz/batchUpdateOverduecontrol', qs.stringify(params))
}




// WEBPACK FOOTER //
// ./src/api/voucher/accountresultbz.js